import {
  DISTRIBUTIONS_REQUEST,
  DISTRIBUTIONS_REQUEST_SUCCESS,
  DISTRIBUTIONS_REQUEST_FAILURE
} from "actions/statistics/distributions-actions";
import { RESET_DATA } from "actions/jobs-tabs-actions";

const INITIAL_STATE = { data: {}, error: null, loading: false };

const DistributionsReducer = (state = INITIAL_STATE, action) => {
  let error;
  switch(action.type) {
    case DISTRIBUTIONS_REQUEST:
      return {...state, error: null, loading: true};
    case DISTRIBUTIONS_REQUEST_SUCCESS:
      return {...state, data: action.payload, loading: false};
    case DISTRIBUTIONS_REQUEST_FAILURE:
      error = action.payload || {message: action.payload.message};
      return {...state, error: error, loading: false};
    case RESET_DATA:
      return {...state, data: {}};
    default:
      return state;
  }
};

export default DistributionsReducer
